import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=37986b47&scoped=true&"
import script from "./GiftList.vue?vue&type=script&lang=ts&"
export * from "./GiftList.vue?vue&type=script&lang=ts&"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=37986b47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37986b47",
  null
  
)

export default component.exports